import { render, staticRenderFns } from "./TopPageLayout.vue?vue&type=template&id=79a0eb76&scoped=true&lang=pug&"
import script from "./TopPageLayout.vue?vue&type=script&lang=ts&"
export * from "./TopPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TopPageLayout.vue?vue&type=style&index=0&id=79a0eb76&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0eb76",
  null
  
)

export default component.exports